import { render, staticRenderFns } from "./lieBianShareUser.vue?vue&type=template&id=06266d50"
import script from "./lieBianShareUser.vue?vue&type=script&lang=js"
export * from "./lieBianShareUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports